import { sessionService, type UserRole } from '@features/auth/services/session.service';
import { useState } from 'react';
import { Label } from '@shared/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@shared/components/ui/select';

/**
 * Role selector dropdown shown on the login screens. Lets the demo switch
 * between the Merchant and Bank experiences before signing in.
 */
export function DevRoleSelector() {
  const [role, setRole] = useState<UserRole>(sessionService.getRole());

  const handleChange = (next: string) => {
    const value = next as UserRole;
    sessionService.setRole(value);
    setRole(value);
  };

  return (
    <div className="flex flex-col gap-2 mb-6">
      <Label htmlFor="role" className="text-sm font-medium text-foreground">
        User Type
      </Label>
      <Select value={role} onValueChange={handleChange}>
        <SelectTrigger id="role" className="w-full rounded-xl">
          <SelectValue placeholder="Select user type" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="merchant">Merchant</SelectItem>
          <SelectItem value="bank">Bank</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}
